import { Card, Col, Row } from "antd";
// import Stepinfo from "Components/Modals/Stepinfo";
import Stepinfo from "../Modals/Stepinfo";
import React, { useState } from "react";
import { connect, useSelector } from "react-redux";
import MyEditor from "Components/RichTextEditor/RichTextEditor";
import TinyEditor from "Components/RichTextEditor/TinyMCE";
import { selectStepReflections, setStepNotifiedAsync, } from "slices/dashboardSlice";
import { pathToStepKey } from "./StaticValues";

const ComingSoonScreenLayout = (props) => {
  
  const [showInfo, setShowInfo] = useState(null)
  const [setTarget, setSetTarget] = useState(null)
  const stepReflections = useSelector(selectStepReflections);
  
  const stepReflectionsStepId = (step) =>
    stepReflections[step] ? stepReflections[step].id : null;
  
  const newReleased = () => props.stepInfo && !props.stepInfo.notified;

  const getShowInfo = () =>{
    showInfo === true ||
    (showInfo === null && newReleased());
  }
  
  const notifyStep = () => {
    if (
      props.stepInfo &&
      !props.stepInfo.notified &&
      props.impersonated
    ) {
      props.setStepNotifiedAsync(
        props.stepInfo.id,
        props.stepInfo.step
      );
    }
  };

  return (
    <>
      <div style={{ padding: "1% 0" }}>
        <Card
            bordered={false}
            style={{
            margin: "20px !important",
            boxShadow: "0px 3px 6px #00000029",
            borderRadius: "13px",
            textAlign: "left",
            marginRight: "6%",
            marginLeft: `${props.collapsed ? "6%" : "20px"}`,
            padding: "0 2%",
            }}
        >
          <div>
            <Row style={{ padding: "4% 0% 3% 0%" }}>
              <Col
              span={18}
              style={{
                  font: "normal normal 300 30px/12px AvenirBook",
                  display: "flex",
                  alignItems: "center",
              }}
              >
                {props.title}
              </Col>
              <Col
                span={6}
                style={{
                  textAlign: "right",
                  fontSize: "26px",
                  marginTop: "-20px",
                }}
              >
                <a
                  href="mailto: team@iamwoken.com?subject=WOKEN client inquiry "
                  target="_blank"
                  style={{
                    marginRight: "10px",
                    cursor:"pointer",
                    opacity: "0",
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                    <g id="mail_2_" data-name="mail (2)" transform="translate(-0.001)">
                      <g id="Group_2502" data-name="Group 2502" transform="translate(0.001)">
                        <path id="Path_1376" data-name="Path 1376" d="M14,0A14,14,0,1,0,28,14,14,14,0,0,0,14,0Zm0,4.917,8.285,5.166H5.716Zm8.388,13.416h0a1.5,1.5,0,0,1-1.5,1.5H7.114a1.5,1.5,0,0,1-1.5-1.5V10.412a1.492,1.492,0,0,1,.024-.257l7.915,4.936.03.016.032.017a.831.831,0,0,0,.172.067l.018,0a.854.854,0,0,0,.2.025h0a.839.839,0,0,0,.2-.025l.018,0a.839.839,0,0,0,.172-.067l.032-.017.03-.016,7.915-4.936a1.49,1.49,0,0,1,.024.257v7.921Z" transform="translate(-0.001)" fill="#199094"/>
                      </g>
                    </g>
                  </svg>
                </a>
                <span
                  onClick={() =>
                    setShowInfo(true)
                  }
                  style={{
                    cursor:"pointer",
                    opacity: "0",
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" style={{marginTop: "5px"}}>
                    <path id="question" d="M14,0A14,14,0,1,0,28,14,14.015,14.015,0,0,0,14,0Zm0,22.167A1.167,1.167,0,1,1,15.167,21,1.167,1.167,0,0,1,14,22.167Zm1.847-7.418a1.172,1.172,0,0,0-.68,1.061v.524a1.167,1.167,0,1,1-2.333,0V15.81a3.515,3.515,0,0,1,2.036-3.18,3.813,3.813,0,0,0,2.047-2.713,2.917,2.917,0,1,0-5.833,0,1.167,1.167,0,1,1-2.333,0,5.25,5.25,0,1,1,10.5,0,6.079,6.079,0,0,1-3.4,4.832Zm0,0" fill="#199094"/>
                  </svg>
                </span>
              </Col>
            </Row>
            <p style={{background: "#FFFFFF 0% 0% no-repeat padding-box", border: "1px solid #F0F0F0"}}></p>
          </div>
          {/* {getShowInfo() ? (
            <Stepinfo
              stepname={props.title}
              closeInfo={() => {
                notifyStep();
                setShowInfo(false)
              }}
            />
          ) : ("")
          } */}
          <div className="editor-wrapper">
            {
              pathToStepKey[props.location.pathname] !== "SE" && pathToStepKey[props.location.pathname] !== "SC" && pathToStepKey[props.location.pathname] !== "MP" && pathToStepKey[props.location.pathname] !== "BL" && pathToStepKey[props.location.pathname] !== "IN" ?
              <TinyEditor stepId={stepReflectionsStepId(pathToStepKey[props.location.pathname])} stepKey={pathToStepKey[props.location.pathname]} /> :
              <div
                style={{
                  height: "700px"
                }}
              ></div>
            }
            {/* <MyEditor stepId={stepReflectionsStepId(pathToStepKey[props.location.pathname])} stepKey={pathToStepKey[props.location.pathname]} /> */}
          </div>
          {/* <div className="component-comingSoom">
            <div style={{marginTop: "20px"}}>Coming Soon</div>
          </div> */}
        </Card>
      </div>
    </> 
  )
}

const mapStateToProps = (state) => ({
  // stepInfo: selectJobSearchStepInfo(state),
  // stepReflections: selectStepReflections(state),
});

const mapDispatchToProps = () => ({
  setStepNotifiedAsync,
});

// export default connect(mapStateToProps, mapDispatchToProps())(ComingSoonScreenLayout);
export default connect(mapStateToProps, mapDispatchToProps())(ComingSoonScreenLayout);
// export default (ComingSoonScreenLayout);